/**
 * Feedback Card — yesterday's performance feedback.
 * Shows emoji + localized text based on completion rate.
 * Background: #182533. Responsive layout.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAuthStore } from '@turnifly/shared/stores'
import { useDailyFeedback } from '@turnifly/shared/hooks'
import { Skeleton } from '@turnifly/shared/ui'
import type { FeedbackResponse } from '@turnifly/shared/types'

export const FeedbackCard: React.FC = () => {
  const { user } = useAuthStore()
  const userId = user?.id
  const { data, isLoading } = useDailyFeedback(userId)
  const feedback = data as FeedbackResponse | undefined
  const { i18n } = useTranslation()

  if (isLoading) {
    return (
      <div className="rounded-xl p-3 bg-[#182533] flex items-center gap-3">
        <Skeleton className="w-8 h-8 rounded-full" />
        <Skeleton className="h-4 w-1/2" />
      </div>
    )
  }

  if (!feedback) return null

  const text = i18n.language === 'en' && feedback.text_en
    ? feedback.text_en
    : feedback.text_uz

  return (
    <div className="rounded-xl p-3 bg-[#182533] flex items-center gap-3">
      <div className="text-2xl shrink-0">{feedback.emoji}</div>
      <p className="text-[13px] font-medium text-text/85 leading-snug">
        {text}
      </p>
    </div>
  )
}
